import React, { useState, useEffect } from "react";
import Loading from "./Loading";

const ImageFromFile = ({ image, className }) => {
  const [url, setUrl] = useState(null)
  const reader = new FileReader()
  reader.onload = function(e) {
    setUrl(e.target.result)
  }

  useEffect(() => {
      reader.readAsDataURL(image)
  }, [image, reader])
  
  if (url) {
    return <img className={className} src={url} alt={image.name} />
  } else {
    return <Loading label='Loading image' />
  }
};

export default ImageFromFile
